import { render, staticRenderFns } from "./ExtraClassAddStudentDialog.vue?vue&type=template&id=18e522d6&scoped=true"
import script from "./ExtraClassAddStudentDialog.vue?vue&type=script&lang=js"
export * from "./ExtraClassAddStudentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e522d6",
  null
  
)

export default component.exports